import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

import { SNACK_BAR } from '../../app.constants';
import { LoadingService } from '../../providers/loading/loading.service';
import { UserService } from '../../providers/user/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent {
  public email = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  public success = false;

  constructor(
    private userService: UserService,
    private snackBar: MatSnackBar,
    private loadingService: LoadingService,
    private readonly router: Router) { }

  public forgot() {
    if (!this.email.valid) {
      return;
    }
    this.loadingService.startLoading();
    this.userService.userForgotPasswordPost({ email: this.email.value })
      .subscribe(
        () => {
          this.loadingService.stopLoading();
          this.snackBar.open('Sent successfully!', '', SNACK_BAR.success);
          this.success = true;
        },
        () => {
          this.loadingService.stopLoading();
          this.snackBar.open('This email does not exist!', '', SNACK_BAR.error);
        });
  }

  public navigateToRegister() {
    this.router.navigate(['/register']);
  }

  public navigateToLogin() {
    this.router.navigate(['/auth']);
  }
}
